import ClipLoader from "react-spinners/ClipLoader";
import styles from "./index.module.css";
import React from "react";

export default props => (
	<div className={props.fullpage ? styles.fullpage : styles.loading}>
		<ClipLoader color="#FFFFFF" />
	</div>
);
